import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

import { ElAlert, ElNotification } from 'element-plus';
import { PropType, Ref, reactive, computed, ref } from 'vue';
import { required } from '@vuelidate/validators';
import { useI18n } from 'vue-i18n';

import { Inspection, UpdateInspectionData } from '@/entities/inspection/types';

import { useFormErrorMessageHandler } from '@/utils/form';
import { useForm } from '@/core/hooks/forms';
import { useGetInspectionQuery, useUpdateInspectionGroupWithInspectionMutation } from '@/entities/inspection/hooks';
// import { useGetWeathersQuery } from '@/entities/weather/hooks';

import {
  NkStack,
  NkForm,
  NkFormItem,
  NkSelect,
  NkOption,
  NkGroup,
  NkButton,
NkDatePicker,
NkTextArea,
NkCheckbox,
} from '@/core/components';
import { InspectionGroup } from '@/entities/inspection-group/types';
import { useGetInspectionGroupQuery } from '@/entities/inspection-group/hooks';


export default /*#__PURE__*/_defineComponent({
  __name: 'InspectionEditForm',
  props: {
  id: {
    type: Number as PropType<Inspection['id']>,
    default: null,
    required: true,
  },
  inspectionGroupId: {
    type: Number as PropType<InspectionGroup['id']>,
    required: true,
  },
},
  emits: [],
  setup(__props, { emit }) {

const props = __props

const { t } = useI18n();




const { onSubmitted } = useForm(emit);

const queryData: Ref = computed(() => ({
  id: props.id,
}));

const inspectionGroupData = computed(() => ({ id: props.inspectionGroupId }));
const { data: inspectionGroup } = useGetInspectionGroupQuery(inspectionGroupData, {
  staleTime: Infinity,
  refetchOnMount: 'always',
});

const {
  data: currentInspection,
  isLoading: isCurrentInspectionLoading,
} = useGetInspectionQuery(queryData, {});

// const { data: weathers, isLoading: isWeathersLoading } = useGetWeathersQuery();

const form = ref();
const allStatus = ref([
  {
    id: 1,
    label: 'To do',
    value: 'todo',
  },
  {
    id: 2,
    label: 'Doing',
    value: 'doing',
  },
  {
    id: 3,
    label: 'Done',
    value: 'done',
  },
]);

const fields = reactive({
  status: currentInspection.value?.status,
  weather: currentInspection.value?.weather,
  device: currentInspection.value?.device,
  inspectionGroup: currentInspection.value?.inspectionGroup,
  date: currentInspection.value?.date,
  comment: inspectionGroup.value?.comment,
  inspectedBySupairvision: inspectionGroup.value?.inspectedBySupairvision,
  id: inspectionGroup.value?.id
});

const rules = {
  status: {
    required,
  },
};

const {
  mutateAsync,
  isLoading,
  isError,
  error: updateInspectionMutation,
} = useUpdateInspectionGroupWithInspectionMutation();

const { error } = useFormErrorMessageHandler(updateInspectionMutation);

const submit = () => {
  form.value.validator.$validate().then((valid: boolean) => {
    if (valid && !isLoading.value) {
      mutateAsync(({
        id: fields.id || 0,
        comment: fields.comment || '',
        inspectedBySupairvision: fields.inspectedBySupairvision || false,
        inspectionDate: fields.date ? new Date(fields.date) : new Date(),
        }),
        {
          onSuccess: () => ElNotification({
            type: 'success',
            position: 'bottom-right',
            title: t('inspection.notification.edit.success.title'),
            message: t('inspection.notification.edit.success.message'),
          }),
        },
      ).then((data) => onSubmitted(data));
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_unref(NkStack), null, {
    default: _withCtx(() => [
      (_unref(isError))
        ? (_openBlock(), _createBlock(_unref(ElAlert), {
            key: 0,
            type: "error",
            title: _unref(error)
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(NkForm), {
        ref_key: "form",
        ref: form,
        fields: fields,
        rules: rules
      }, {
        footer: _withCtx(() => [
          _createVNode(_unref(NkGroup), { position: "right" }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_unref(NkButton), { onClick: submit }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('actions.update')), 1)
                ]),
                _: 1
              })), [
                [_directive_loading, _unref(isLoading)]
              ])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(NkFormItem), {
            prop: "date",
            label: _ctx.$t('inspection-group.form.field.date.label')
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkDatePicker), {
                modelValue: fields.date,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fields.date) = $event)),
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_unref(NkFormItem), {
            prop: "comment",
            label: _ctx.$t('inspection-group.form.field.comment.label')
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkTextArea), {
                modelValue: fields.comment,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fields.comment) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.$store.getters['connection/isGranted'](['ROLE_ADMIN']))
            ? (_openBlock(), _createBlock(_unref(NkFormItem), {
                key: 0,
                prop: "inspectedBySupairvision"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NkCheckbox), {
                    modelValue: fields.inspectedBySupairvision,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fields.inspectedBySupairvision) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('inspection-group.form.field.inspectionBySupairvision.label')), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["fields"])
    ]),
    _: 1
  })), [
    [_directive_loading, _unref(isCurrentInspectionLoading)]
  ])
}
}

})